// extracted by mini-css-extract-plugin
export var blog_page_title = "index-module--blog_page_title---TLr2";
export var category_blog = "index-module--category_blog--N92j+";
export var category_blog_container = "index-module--category_blog_container--0cCAs";